import React, { useEffect, useState } from "react";
import { renderError } from "../../../helpers/errors";
import { createOptions } from "../../../helpers/selects";
import api from "../../../services/api";
import InputSelect from "../../InputSelect";
import moment from "moment";
import { convertIntToMoney } from "../../../helpers/conversions";

export const SelectContaPagar = ({selectedContaPagar, setSelectedContaPagar}) => {
    const [loading, setLoading] = useState(true);
    const [options, setOptions] = useState([]);

    useEffect(() => {
        getContasPagar();
    }, []);

    const getContasPagar = () => {
        setLoading(true);

        api.get(`/conta-pagar`).then(res => {
            getOptions(res.data.resources);
        }).catch(error => {
            renderError(error);
        }).then(() => {
            setLoading(false);
        });
    }

    const getOptions = contas => {
        let toOptions = [];
        contas.map(conta => {
            toOptions.push({
                value: conta.id,
                label: `${moment(conta.vencimento).format('DD/MM/YYYY')} - ${convertIntToMoney(conta.valor, true)} - ${conta?.fornecedor?.nome}`
            });
        });
        setOptions(toOptions);
    }

    return (
        <InputSelect
            loading={loading}
            label={`Conta a pagar`}
            options={options} 
            value={selectedContaPagar} 
            change={setSelectedContaPagar}
        />
    );
}

export default SelectContaPagar;